import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconComponent} from "../icon/icon.component";


@Component({
    selector: 'app-payment-status',
    imports: [
    IconComponent
],
    templateUrl: './payment-status.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './payment-status.component.scss'
})
export class PaymentStatusComponent {
  @Input() isPaid!: boolean;
  @Input() shortenOnMobile: boolean = false;
}
